import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import router from '../router'
import Vue from 'vue'
import { getUserTokenKey, setLogoutFlag } from '@/utils/auth'

// 专业版的时候

let dialogFlag = true
// eslint-disable-next-line no-unused-vars
import { getToken, removeToken, setToken } from '@/utils/auth'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 * 10 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // 设置本地开发Token
    if (process.env.NODE_ENV === 'development') {
      // setToken('[B@10163835')
    }
    // do something before request is sent
    // let each request carry token
    // please modify it according to the actual situation
    if (Vue.prototype.$isInKa) {
      config.headers['x-baojia-user'] = getToken()
    } else if (Vue.prototype.$isInFrame) {
      config.headers['X-Token'] = getToken()
    } else {
      const isConsole = sessionStorage.getItem('isConsole')
      if (isConsole) {
        config.headers['C-Token'] = getToken()
      } else {
        config.headers['S-Token'] = getToken()
      }
      if (sessionStorage.getItem('appId')) {
        config.headers['app-id'] = sessionStorage.getItem('appId')
      }
    }
    let ssoToken = getUserTokenKey()
    if (store.state.user.ssoToken) {
      ssoToken = store.state.user.ssoToken
    }
    const isSsoToken = localStorage.getItem('is-sso-login')
    if (ssoToken && isSsoToken) {
      config.headers['xxh-sso-token'] = ssoToken
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  // 正常获取数据
  (response) => {
    const list = [
      'x-pkcs7-certificates',
      'vnd.ms-excel',
      'pem',
      'zip',
      'application/pdf'
    ]
    const flag = list.some(
      (x) =>
        response.headers['content-type'] &&
        response.headers['content-type'].indexOf(x) > -1
    )
    // mock数据处理，正式对接接口时移除
    // if (response.data && process.env.NODE_ENV === 'development') {
    //   return response.data
    // }
    const bullet = [
      '6000',
      '6001',
      '6002',
      '6003',
      '6004',
      '6005',
      '6007',
      '7000',
      '17',
      '61'
    ]
    const isWarn = ['-1', '-4', '37', '36']
    if (
      (response.headers['content-type'] != null && flag) ||
      response.data instanceof Blob
    ) {
      return response
    }
    // eslint-disable-next-line eqeqeq
    if (
      response.data &&
      // eslint-disable-next-line eqeqeq
      (response.data.code == 0 ||
        response.data.code === 200 ||
        response.data.code === '200' ||
        response.data.code === 19 ||
        response.data.code === 10001 ||
        response.data.code === '30001' ||
        response.data.code === '30002' ||
        response.data.code === '40001')
    ) {
      return response.data
    } else if (bullet.indexOf(response.data.code + '') >= 0) {
      // 提示弹框
      //           - 6000  未绑定席位
      //           - 6001  当前无可用座席，请联系管理员
      //           - 6002  席位或者用户已绑定，请重新刷新
      //           - 6003  席位绑定失败
      //           - 6004  改席位正在使用
      //           - 6005  未找到席位
      //           - 7000  记录拨打信息失败
      //           - 17    无通话记录
      //           - 61    车型车系被关联无法删除
      return response.data
    } else if (response.data.code === '60') {
      // 后台转换客户id的时候，cdp第二天才会返回。  继续处理当前线索或商机详情
      // Message({
      //   type: 'error',
      //   message: response.data.message || response.data.msg || response.msg
      // })
      return response.data
    } else if (response.data.code === '8' || response.data.code === '9') {
      // 抱歉，你无权访问该页面
      // process.env.NODE_ENV === 'pre' && (window.location.href = 'http://prewww.71360.com/product/scrm.html')
      // process.env.NODE_ENV === 'production' && (window.location.href = 'http://www.71360.com/product/scrm.html')
    // eslint-disable-next-line eqeqeq
    } else if (response.data.code == 401 || response.data.code == 7) {
      // 用户信息已过期 或者用户已离职1
      if (dialogFlag) {
        dialogFlag = false
        Message({
          type: 'error',
          message: response.data.message || response.data.msg || response.msg
        })
      }
      if (Vue.prototype.$isInFrame) {
        return false
      }
      removeToken()
      setLogoutFlag()
      localStorage.removeItem('accountName')
      setTimeout(() => {
        dialogFlag = true
        let ssoToken = getUserTokenKey()
        const isYc = sessionStorage.getItem('isYc')
        if (store.state.user.ssoToken) {
          ssoToken = store.state.user.ssoToken
        }
        const isSsoLogin = localStorage.getItem('is-sso-login')
        if (ssoToken && isSsoLogin) {
          store.commit('user/SET_SSOTOKEN', '')
          localStorage.removeItem('is-sso-login')
          if (process.env.NODE_ENV === 'production' && process.env.VUE_APP_SECRET === 'prod') {
            window.location.href = `https://in-sso.71360.com/logout?token=${ssoToken}&backUrl=https://bpm.71360.com/`
          } else {
            window.location.href = `https://prein-sso.71360.com/logout?token=${ssoToken}&backUrl=https://prebpm.71360.com/`
          }
        } else if (isYc) {
          window.location.href = process.env.VUE_APP_YC_domain
        } else {
          const isConsole = sessionStorage.getItem('isConsole')
          const backUrl = sessionStorage.getItem('backUrl')
          if (isConsole) {
            if (backUrl) {
              window.location.href = backUrl
              return
            } else {
              window.location.href = process.env.VUE_APP_CONSOLEURL
              return
            }
          }
          router.push({
            path: '/login',
            query: { backUrl: window.location.href }
          })
        }
      }, 1000)
    } else if (response.data.code === 510) {
      // 510位表单验证不通过时 去报errorList里的内容
      Message.error(response.data.errorList[0].errorInfo)
    } else if (response.data.code > 200 && response.data.code < 300) {
      // 不显示报错弹框
    } else if (response.data.code === '32' || response.data.code === '28') {
      // 关联信息 :32(商品)、28(商机)
      return response.data
    } else if (isWarn.indexOf(response.data.code + '') >= 0) {
      Message({
        type: 'error',
        message: response.data.message || response.data.msg || response.msg
      })
      // cdp下载接口，后端返回数据流文件，不做处理会报错，并且拿不到报错信息和流文件
    } else if (
      response.headers['content-type'] != null &&
      ['application/octet-stream'].includes(response.headers['content-type'])
    ) {
      return response.data
    } else {
      // 积分商城状态值为200代表成功返回数据没有code
      if (response.data.code) {
        Message({
          type: 'error',
          message: response.data.message || response.data.msg || response.msg
        })
      } else {
        return response.data
      }
    }
    return Promise.reject(response)
  },
  // 请求失败
  (error) => {
    // 积分商城状态值不是200代表请求失败返回数据有code需要给用户提示
    if (
      error.response &&
      error.response.data.code &&
      // eslint-disable-next-line eqeqeq
      error.response.data.code != 4024
    ) {
      Message({
        type: 'error',
        message: error.response.data.message || error.response.data.msg
      })
    }
    return Promise.reject(error)
  }
)

export default service
